<template>
<div class="chapter">
<div class="inner_page">
<p class="noindentf"><a id="fm02"></a><a id="page_ii"></a><strong>Johns Hopkins Studies in the History of Technology</strong></p>
<p class="noindentf1"><span class="smallcaps">MERRITT ROE SMITH, SERIES EDITOR</span></p>
<p class="noindentf2"><span class="smallcaps">THE JOHNS HOPKINS UNIVERSITY PRESS</span> <em>Baltimore</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm02.vue?0f532d6c